import api from './api';

export interface SyncResponse {
    message: string;
    total_asaas: number;
    importados: number;
    ja_existiam: number;
}

export const asaasService = {
    syncCustomers: async () => {
        const response = await api.post<SyncResponse>('/asaas/sync/customers');
        return response.data;
    },
    syncPayments: async () => {
        const response = await api.post<SyncResponse>('/asaas/sync/payments');
        return response.data;
    }
};
